import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { OutsideZone } from './zone/zone.decorators';

@Injectable({
    providedIn: 'root'
})
export class DebugService {

    #print(data: any, key?: string) {
        if (typeof data === 'object') {
            if (Array.isArray(data)) {
                if (data.length === 0) {
                    console.info(`Empty Array`);
                    return;
                }

                console.groupCollapsed(key ? `${key} - Array` : 'Array');
                console.table(data);
                console.groupEnd();
                return;
            } else {
                const logProps: any = {};
                const deepProps: any = {};
                for (const prop in data) {
                    if (Array.isArray(data[prop]) || typeof data[prop] === 'object') {
                        deepProps[prop] = data[prop];
                        logProps[prop] = Array.isArray(data[prop]) ? 'Array' : 'Object';
                        continue;
                    }

                    logProps[prop] = data[prop];
                }

                console.groupCollapsed(key ? `${key} - Object` : 'Object');

                if (Object.keys(logProps).length > 0)
                    console.table(logProps);

                Object
                    .entries(deepProps)
                    .forEach(kv => {
                        this.#print(kv[1], kv[0]);
                    });

                console.groupEnd();


                return;
            }
        }

        if (key) {
            console.info(`${key}`, data);
            return;
        }


        console.info(data);
    }

    @OutsideZone()
    printHttpResponseBody(httpResponse: HttpResponse<any>, start: number) {
        const url = httpResponse.url;
        const body = httpResponse.body;

        if (!environment.production && body) {
            console.groupCollapsed(`Request Response: ${url}`);
            console.info(`Request took: ${(performance.now() - start) / 1000}s`);
            this.#print(body, 'Response Body');
            console.groupEnd();
        }
    }

}